import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.reduce.js";
import "core-js/modules/web.dom-exception.stack.js";
import "core-js/modules/web.structured-clone.js";
const __default__ = {
  name: "School",
  data() {
    return {
      barData: [],
      pieChartData: [],
      currentObj: {},
      currentDate: "",
      updatedAt: "",
      schools: [],
      totalStudents: 0,
      totalAbsence: 0,
      totalInfection: 0,
      targetSchool: {},
      schoolBarData: [],
      schoolPieChartData: [],
      schoolMonthData: {},
      calenderMonth: {},
      calenderFirstDay: "",
      todaysMonth: {},
      schoolIdSelected: this.$route.params.id,
      monthList: [],
      barMonth: "",
      schoolBarMonth: "",
      selectedDay: moment().format("YYYY-MM-DD"),
      // 当日の日付
      schoolBarStackedData: {},
      intervalId: undefined
    };
  },
  head: {
    title: {
      inner: "スクール"
    },
    meta: []
  },
  watch: {
    isAuthenticated: {
      async handler(v) {
        if (v) {
          this.barMonth = "current";
          this.schoolBarMonth = "current";
          const data = await Promise.all([getData(`attendance_summary?dashboard=1&date=${this.selectedDay}`), getData(`attendance_summary?pieChart=1&date=${this.selectedDay}&school_type=all`), getData(`attendance_summary?bar=1&to=${this.selectedDay}`), getData(`attendance_summary?schoolPieChart=${this.$route.params.id}&date=${this.selectedDay}`), getData(`attendance_summary?schoolBar=${this.$route.params.id}&to=${this.selectedDay}`), getData(`grade?schoolTable=${this.$route.params.id}&date=${moment(this.selectedDay).startOf("month").format("YYYY-MM-DD")}`), getData(`grade?schoolBarStacked=${this.$route.params.id}`)]);
          const absenceBySchool = data[0].items;
          this.pieChartData = data[1].items;
          this.barData = data[2].items;
          this.schoolPieChartData = data[3].items;
          this.schoolBarData = data[4].items;
          this.schoolMonthData = data[5].items;
          this.schoolBarStackedData = data[6].items;
          this.schools = this.mergeSchoolAbsence(absenceBySchool);
          this.getTotal();
          this.targetSchool = this.schools.find(v => v.id === Number(this.$route.params.id));
        }
      },
      immediate: true
    },
    async $route() {
      if (this.$auth.isAuthenticated) {
        const data = await Promise.all([getData(`attendance_summary?schoolPieChart=${this.$route.params.id}&date=${this.selectedDay}`), getData(`attendance_summary?schoolBar=${this.$route.params.id}&to=${this.selectedDay}`), getData(`grade?schoolTable=${this.$route.params.id}&date=${this.calenderFirstDay}`), getData(`grade?schoolBarStacked=${this.$route.params.id}`)]);
        this.schoolPieChartData = data[0].items;
        this.schoolBarData = data[1].items;
        this.schoolMonthData = data[2].items;
        this.schoolBarStackedData = data[3].items;
        this.targetSchool = this.schools.find(v => v.id === Number(this.$route.params.id));
        this.schoolIdSelected = this.$route.params.id;
      }
      this.autoUpdateValue();
    }
  },
  created() {
    moment.locale("ja");
    this.currentObj = moment();
    this.currentDate = this.currentObj.format("YYYY年MM月DD日");
    this.updatedAt = this.currentObj.format("HH時mm分");
    this.todaysMonth = this.currentObj.clone().startOf("month");
    this.calenderMonth = this.todaysMonth.clone();
    this.calenderFirstDay = this.calenderMonth.format("YYYY-MM-DD");
    this.createMonthList();
  },
  mounted() {
    this.autoUpdateValue();
  },
  beforeDestroy() {
    clearInterval(this.intervalId);
  },
  methods: {
    // 10分ごとの自動更新
    autoUpdateValue() {
      this.intervalId = setInterval(async () => {
        if (this.$auth.isAuthenticated) {
          const data = await Promise.all([getData(`attendance_summary?dashboard=1&date=${this.selectedDay}`), getData(`attendance_summary?pieChart=1&date=${this.selectedDay}&school_type=all`), this.barMonth === "current" ? getData(`attendance_summary?bar=1&to=${this.selectedDay}`) : getData(`attendance_summary?bar=1&${this.barMonth}`), getData(`attendance_summary?schoolPieChart=${this.$route.params.id}&date=${this.selectedDay}`), this.schoolBarMonth === "current" ? getData(`attendance_summary?schoolBar=${this.$route.params.id}&to=${this.selectedDay}`) : getData(`attendance_summary?schoolBar=${this.$route.params.id}&${this.schoolBarMonth}`), getData(`grade?schoolTable=${this.$route.params.id}&date=${this.calenderMonth.startOf("month").format("YYYY-MM-DD")}`), getData(`grade?schoolBarStacked=${this.$route.params.id}&date=${this.selectedDay}`)]);
          const absenceBySchool = data[0].items;
          this.pieChartData = data[1].items;
          this.barData = data[2].items;
          this.schoolPieChartData = data[3].items;
          this.schoolBarData = data[4].items;
          this.schoolMonthData = data[5].items;
          this.schoolBarStackedData = data[6].items;
          this.schools = this.mergeSchoolAbsence(absenceBySchool);
          this.getTotal();
          this.currentObj = moment(); // 当日の日付
          this.currentDate = this.currentObj.format("YYYY年MM月DD日");
          this.updatedAt = this.currentObj.format("HH時mm分");
        }
        // 10分の時は600000
      }, 600000);
    },
    // カレンダーの日付が変更されたとき
    async changeDate() {
      // console.log(this.selectedDay);
      if (this.$auth.isAuthenticated) {
        const data = await Promise.all([getData(`attendance_summary?dashboard=1&date=${this.selectedDay}`), getData(`attendance_summary?pieChart=1&date=${this.selectedDay}&school_type=all`), getData(`attendance_summary?bar=1&to=${this.selectedDay}`), getData(`attendance_summary?schoolPieChart=${this.$route.params.id}&date=${this.selectedDay}`), getData(`attendance_summary?schoolBar=${this.$route.params.id}&to=${this.selectedDay}`), getData(`grade?schoolBarStacked=${this.$route.params.id}&date=${this.selectedDay}`)]);
        const absenceBySchool = data[0].items;
        this.pieChartData = data[1].items;
        this.barData = data[2].items;
        this.schoolPieChartData = data[3].items;
        this.schoolBarData = data[4].items;
        this.schoolBarStackedData = data[5].items;
        this.schools = this.mergeSchoolAbsence(absenceBySchool);
        this.getTotal();
      }
    },
    getTotal() {
      [this.totalStudents, this.totalAbsence, this.totalInfection] = this.schools.reduce((sum, v) => {
        return [sum[0] + v.student_count, sum[1] + v.pointsMap.absencePointsMap, sum[2] + v.pointsMap.infection];
      }, [0, 0, 0]);
    },
    schoolChange() {
      if (this.schoolIdSelected === "dashboard") {
        this.$router.push("/dashboard");
      } else {
        this.$router.push(`/school/${this.schoolIdSelected}`);
        clearInterval(this.intervalId);
      }
    },
    async changePrevMonth() {
      if (this.calenderMonth.month() !== 3 && this.$auth.isAuthenticated) {
        this.calenderMonth.subtract(1, "month");
        this.calenderFirstDay = this.calenderMonth.format("YYYY-MM-DD");
        const data = await getData(`grade?schoolTable=${this.$route.params.id}&date=${this.calenderFirstDay}`);
        this.schoolMonthData = data.items;
      }
    },
    async changeNextMonth() {
      if (this.calenderMonth < this.todaysMonth && this.$auth.isAuthenticated) {
        this.calenderMonth.add(1, "month");
        this.calenderFirstDay = this.calenderMonth.format("YYYY-MM-DD");
        const data = await getData(`grade?schoolTable=${this.$route.params.id}&date=${this.calenderFirstDay}`);
        this.schoolMonthData = data.items;
      }
    },
    createMonthList() {
      this.monthList = [{
        month: this.todaysMonth.month() + 1,
        period: `from=${this.todaysMonth.format("YYYY-MM-DD")}&to=${this.currentObj.format("YYYY-MM-DD")}`
      }];
      for (const d = this.todaysMonth.clone().subtract(1, "month"); d.month() !== 2; d.subtract(1, "month")) {
        this.monthList.push({
          month: d.month() + 1,
          period: `from=${d.format("YYYY-MM-DD")}&to=${d.clone().endOf("month").format("YYYY-MM-DD")}`
        });
      }
    },
    async barMonthChange() {
      if (this.$auth.isAuthenticated) {
        if (this.barMonth === "current") {
          const data = await getData(`attendance_summary?bar=1&to=${this.selectedDay}`);
          this.barData = data.items;
        } else {
          const data = await getData(`attendance_summary?bar=1&${this.barMonth}`);
          this.barData = data.items;
        }
      }
    },
    async schoolBarMonthChange() {
      if (this.$auth.isAuthenticated) {
        if (this.schoolBarMonth === "current") {
          const data = await getData(`attendance_summary?schoolBar=${this.$route.params.id}&to=${this.selectedDay}`);
          this.schoolBarData = data.items;
        } else {
          const data = await getData(`attendance_summary?schoolBar=${this.$route.params.id}&${this.schoolBarMonth}`);
          this.schoolBarData = data.items;
        }
      }
    }
  }
};
import { inject } from "vue";
import moment from "moment";
import { getData } from "@/services/axios";
import PieChart from "@/components/charts/PieChart";
import Bar from "@/components/charts/Bar";
import PointsMap from "@/components/charts/PointsMap";
import CalenderTable from "@/components/schools/CalenderTable";
import BarStacked from "@/components/charts/BarStacked";
import Inc137 from "@/components/common/Inc137";

import { isAuthenticatedKey, allSchoolListKey, meKey } from '/codebuild/output/src2081543335/src/cocoo_gov/src/utils/injectionKey.js';
export default /*#__PURE__*/Object.assign(__default__, {
  setup(__props, {
    expose
  }) {
    const isAuthenticated = inject(isAuthenticatedKey);
    const allSchoolList = inject(allSchoolListKey);
    const me = inject(meKey);

    // 表と地図のデータ作成
    const mergeSchoolAbsence = absenceBySchool => {
      return allSchoolList.value.map(v => {
        const school = structuredClone(v);
        const absence = absenceBySchool.find(w => w.school_id === school.id);
        if (absence) {
          school["absence"] = absence;
          school["pointsMap"] = {
            absencePointsMap: absence.absencePointsMap,
            infection: Object.keys(absence).reduce((sum, key) => {
              return key.match(/感染症/) ? sum + absence[key] : sum;
            }, 0)
          };
        } else {
          // 欠席者がいないとき
          school["absence"] = {
            total: 0
          };
          school["pointsMap"] = {
            absencePointsMap: 0,
            infection: 0
          };
        }
        return school;
      });
    };
    expose({
      isAuthenticated,
      mergeSchoolAbsence
    });
    return {
      __sfc: true,
      isAuthenticated,
      allSchoolList,
      me,
      mergeSchoolAbsence,
      PieChart,
      Bar,
      PointsMap,
      CalenderTable,
      BarStacked,
      Inc137
    };
  }
});